import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import Slider from '../slider/slider.component';
import './profile-list.component.scss';
var ProfileList = /** @class */ (function (_super) {
    tslib_1.__extends(ProfileList, _super);
    function ProfileList(element) {
        return _super.call(this, element) || this;
    }
    ProfileList.prototype.init = function () {
        var _this = this;
        if (Number(this.element.getAttribute('data-items'))) {
            this.sliderItems = Number(this.element.getAttribute('data-items'));
        }
        else {
            this.sliderItems = 3;
        }
        this.sliderContainer = this.element.querySelector('.swiper-container');
        this.sliderPagination = this.element.querySelector('.swiper-pagination');
        this.sliderNext = this.element.querySelector('.swiper-button-next');
        this.sliderPrev = this.element.querySelector('.swiper-button-prev');
        this.windowWidth = document.documentElement.clientWidth;
        this.tabsDesktopSelector = Array.from(this.element.querySelectorAll('.js-tab-trigger'));
        this.tabsContainers = Array.from(this.element.querySelectorAll('.tabs__item-content'));
        this.tabsSelect = this.element.querySelector('.js-option-selector');
        if (this.element.classList.contains('js-profile-carousel')) {
            this.breakpoints = {
                992: {
                    initialSlide: 0,
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                576: {
                    initialSlide: 0,
                    slidesPerView: 1.1,
                    spaceBetween: 15,
                }
            };
        }
        else {
            switch (this.sliderItems) {
                case 1:
                    this.breakpoints = {};
                    break;
                case 2:
                    this.breakpoints = {
                        576: {
                            initialSlide: 0,
                            slidesPerView: 1.3,
                            spaceBetween: 15,
                        }
                    };
                    break;
                default:
                    this.breakpoints = {
                        1200: {
                            initialSlide: 0,
                            slidesPerView: 2.1,
                            spaceBetween: 30,
                        },
                        768: {
                            initialSlide: 0,
                            slidesPerView: 2.1,
                            spaceBetween: 20,
                        },
                        576: {
                            initialSlide: 0,
                            slidesPerView: 1.1,
                            spaceBetween: 15,
                        }
                    };
                    break;
            }
        }
        this.sliderConfig = {
            slidesPerView: this.sliderItems,
            spaceBetween: 30,
            initialSlide: 0,
            breakpoints: this.breakpoints,
            pagination: {
                el: this.sliderPagination,
                type: 'bullets',
                clickable: true
            },
            navigation: {
                nextEl: this.sliderNext,
                prevEl: this.sliderPrev,
            }
        };
        Slider.init(this.sliderContainer, this.sliderConfig);
        this.removeHeightsAuto();
        // Mobile button logic
        this.addMobileButton();
        // Listen for window resize events to recheck mobile button visibility
        window.addEventListener('resize', function () { return _this.addMobileButton(); });
    };
    ProfileList.prototype.bindEvents = function () {
        var _this = this;
        if (this.tabsSelect) {
            this.tabsSelect.addEventListener('change', function (event) {
                var element = event.target;
                var index = element.selectedIndex;
                var value = element.value;
                _this.showTabContentMobile(index);
            });
        }
        if (this.tabsDesktopSelector) {
            this.tabsDesktopSelector.map(function (item) { return item.addEventListener('click', function (event) {
                var element;
                if (event.currentTarget) {
                    element = event.currentTarget;
                }
                else {
                    element = event.target;
                }
                var id = element.getAttribute('data-target');
                _this.showTabContentDesktop(id);
            }); });
        }
        $(this.element).on('click', '.js-video-play', function (event) {
            _this.showVideo(event);
        });
        $(this.element).on('click', '.js-video-close', function (event) {
            _this.hideVideo(event);
        });
    };
    ProfileList.prototype.removeHeightsAuto = function () {
        var index = 0;
        this.tabsContainers.map(function (container) {
            if (index !== 0) {
                container.classList.add('profile-list__tabs-container--hidden');
            }
            index++;
        });
    };
    ProfileList.prototype.showTabContentMobile = function (indexSelected) {
        var index = 0;
        this.tabsContainers.map(function (container) {
            container.classList.add('profile-list__tabs-container--hidden');
            container.classList.remove('tabs__item-content--active');
            if (index === indexSelected) {
                container.classList.add('tabs__item-content--active');
                container.classList.remove('profile-list__tabs-container--hidden');
            }
            index++;
        });
    };
    ProfileList.prototype.showTabContentDesktop = function (id) {
        this.tabsContainers.map(function (container) {
            container.classList.add('profile-list__tabs-container--hidden');
            container.classList.remove('tabs__item-content--active');
            if (container.id === id) {
                container.classList.add('tabs__item-content--active');
                container.classList.remove('profile-list__tabs-container--hidden');
            }
        });
    };
    ProfileList.prototype.showVideo = function (event) {
        var element = event.target;
        if (this.element.classList.contains('profile-list-filter')) {
            this.hideActiveVideo(element);
            if (element.hasAttribute('data-youtube-id')) {
                this.playerContainer = element.closest('.video-carousel-item__container');
                this.playerContent = this.playerContainer.querySelector('.video-carousel-item__playercontent');
                this.playerContainer.classList.add('video-carousel-item__container--playing');
                this.isExternal = true;
                var getYoutubeId = element.getAttribute('data-youtube-id');
                this.createIframePlayer(getYoutubeId);
            }
            else if (element.hasAttribute('data-vidavee-id')) {
                this.playerContainer = element.closest('.video-carousel-item__container');
                this.playerContent = this.playerContainer.querySelector('.video-carousel-item__playercontent');
                this.playerContainer.classList.add('video-carousel-item__container--playing');
                this.isExternal = true;
                var getVidaveeId = element.getAttribute('data-vidavee-id');
                this.createIframePlayer(getVidaveeId, true);
            }
        }
    };
    ProfileList.prototype.hideVideo = function (event) {
        var removeIframe = this.playerContent.querySelector('iframe');
        this.playerContainer.classList.remove('video-carousel-item__container--playing');
        if (removeIframe) {
            this.playerContent.removeChild(removeIframe);
        }
    };
    ProfileList.prototype.hideActiveVideo = function (element) {
        var selectedVideo = element.closest('.video-carousel-item__container');
        if (!selectedVideo.classList.contains('video-carousel-item__container--playing')) {
            var videoContainers = Array.from(document.querySelectorAll('.video-carousel-item__container--playing'));
            videoContainers.map(function (itemContainer) {
                itemContainer.classList.remove('video-carousel-item__container--playing');
                var iframeExistence = itemContainer.querySelector('iframe');
                if (iframeExistence) {
                    var iframeChildren = $(itemContainer).find('iframe');
                    iframeChildren.remove();
                }
                else {
                    var videoChildren = itemContainer.querySelector('video');
                    var playerChildren = itemContainer.querySelector('.ot-video-containingBlock');
                    videoChildren.pause();
                }
            });
        }
    };
    ProfileList.prototype.createIframePlayer = function (url, vidavee) {
        if (vidavee === void 0) { vidavee = false; }
        if (vidavee) {
            var externalUrl = '/vidaveePlayer.jsp?remoteId=';
            externalUrl += url;
            var createIframe = document.createElement('iframe');
            createIframe.id = 'video__external';
            createIframe.src = externalUrl;
            createIframe.classList.add('video__iframe');
            this.playerContent.appendChild(createIframe);
        }
        else {
            var externalUrl = 'https://www.youtube.com/embed/';
            externalUrl += url;
            externalUrl += '?rel=0&amp;showinfo=0&autoplay=1&enablejsapi=1';
            var createIframe = document.createElement('iframe');
            createIframe.id = 'video__external';
            createIframe.src = externalUrl;
            createIframe.classList.add('video__iframe');
            this.playerContent.appendChild(createIframe);
        }
    };
    // Mobile button logic
    ProfileList.prototype.addMobileButton = function () {
        var viewAllLink = this.element.querySelector('.view-all-link');
        var mobileButton = this.element.querySelector('.profile-list__view-more--button d-none');
        // screens (max-width 768px)
        if (viewAllLink && mobileButton) {
            if (window.innerWidth <= 768) {
                mobileButton.classList.remove('d-none');
            }
            else {
                mobileButton.classList.add('d-none');
            }
        }
    };
    return ProfileList;
}(Base));
export { ProfileList };



//////////////////
// WEBPACK FOOTER
// ./components/profile-list/profile-list.component.ts
// module id = 455
// module chunks = 0